import React from "react";
import { Link } from "react-router-dom";

export const LogoMark = ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
        <defs>
            <linearGradient id="xt-g" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#059669" />
                <stop offset="1" stopColor="#047857" />
            </linearGradient>
        </defs>
        <rect width="64" height="64" rx="16" fill="url(#xt-g)" />
        <path d="M20 20 L44 44" stroke="#FFFFFF" strokeWidth="7" strokeLinecap="round" />
        <path d="M44 20 L20 44" stroke="#6EE7B7" strokeWidth="7" strokeLinecap="round" />
        <path d="M44 20 C38 14, 30 16, 27 21 C31 26, 40 26, 44 20 Z" fill="#A7F3D0" />
    </svg>
);

export default function Logo({ dark = false, compact = false }) {
    return (
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
            <div className="transition-transform duration-300 group-hover:rotate-6 group-hover:scale-105">
                <LogoMark />
            </div>
            {!compact && (
                <div className="leading-none">
                    <div className={`font-display font-bold tracking-tight text-xl ${dark ? "text-white" : "text-forest-900"}`}>
                        X Terminate <span className="text-forest-600">Ltd</span>
                    </div>
                    <div className={`text-[11px] tracking-[0.18em] uppercase mt-1 ${dark ? "text-forest-200" : "text-forest-700/70"}`}>
                        Premium · Mauritius
                    </div>
                </div>
            )}
        </Link>
    );
}